export default "__VITE_ASSET__DmYOS6vl__"